<template>
    <div class="top-container">
        <PwaDownloadCard @intallPWA="intallPWA" @isClosedPWA="isClosedPWA" />
        <van-row class="header" justify="space-between">
            <van-col span="2" @click="openSidebar" class="header_item_menu">
                <van-badge v-if="batchContent > 0" :content="batchContent">
                    <img :src="sideIconData.url" alt="" v-if="sideIconData.display">
                </van-badge>
                <div v-else>
                    <img :src="sideIconData.url" alt="" v-if="sideIconData.display">
                </div>
            </van-col>
            <van-col :span="userStore.loginAccount ? 8 : 10" class="header_item_logo">
                <img :src="appIconData.url" alt="" v-if="appIconData.display">
            </van-col>
            <van-col v-if="userStore.loginAccount" span="11" class="header_button_item" align="center">
                <div v-if="depositButtonData.display" @click="goToDeposit" class="coin_btn"
                    :style="{ backgroundImage: depositButtonData.colorCode }">
                    <div>{{ formatCurrency(balance) }}</div>
                    <span>
                        <img src="@/assets/common/plus.png" alt="">
                    </span>
                </div>
                <div v-if="profileButtonData.display" class="avatar_btn">
                    <img src="@/assets/common/head_icon.jpg" alt="" @click="goToProfile">
                    <span class="more_img">
                        <img :src="profileButtonData.url" alt="">
                    </span>
                </div>
            </van-col>
            <van-col v-if="!userStore.loginAccount" span="9" class="header_button_item" align="center">
                <van-row>
                    <van-col span="12" class="login_btn">
                        <div @click="openRegisterPopup(1)" class="loginBtn">{{ $t('common.login') }}</div>
                    </van-col>
                    <van-col span="11" offset="1" class="register_btn">
                        <div @click="openRegisterPopup(0)" class="registerBtn">{{ $t('common.register') }}</div>
                    </van-col>
                </van-row>
            </van-col>
            <van-col :span="1" style="align-items: center;display: flex;">
                <!-- <img src="@/assets/theme/threeDot.png" height="15" width="15" @click="handleThemeChange"> -->
            </van-col>
        </van-row>
        <SideNavbar ref="sideNavbarRef" :listGameData="listGameData" @goToGamePanelSlide="goToGamePannelSidePannel" />
        <ThemeChangePopup ref="themeChangeRef" />
    </div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import SideNavbar from "../sideNav/sideNavbar.vue"
import { ref, defineEmits, inject, computed, defineProps, onMounted } from 'vue';
import { playClickSound } from "@/utils/media";
import { useUserStore } from "@/stores/user";
import { formatCurrency } from "@/utils/commonFunction";
import PwaDownloadCard from "../../home/components/pwaDownloadCard.vue";
import ThemeChangePopup from "./themeChangePopup.vue";
const router = useRouter();
const openRegisterLoginPopup = inject<(type: number) => void>('openRegisterLoginPopup')
const sideNavbarRef = ref()
const themeChangeRef = ref()
const batchContent = ref(0)
const token = ref(localStorage.getItem('token'))
const isLogin = ref(token.value ? true : false)
const userStore = useUserStore()
const balance = computed(() => userStore.balance)

const props = defineProps<{
    itemData: {
        appIcon: {
            url: string,
            display: boolean
        },
        sideIcon: {
            url: string,
            display: boolean
        },
        depositButton: {
            colorCode: string,
            display: boolean,
            redirectUrl: string
        },
        profileButton: {
            url: string,
            display: boolean,
            redirectUrl: string
        },
    },
    listGameData: {
        name: string,
        customIcon: string,
        id: number
    }[]
}>()
const appIconData = ref({
    url: props.itemData.appIcon.url,
    display: props.itemData.appIcon.display
})

const listGameData = computed(() => props.listGameData);
const sideIconData = ref({
    url: props.itemData.sideIcon.url,
    display: props.itemData.sideIcon.display,
})
const depositButtonData = ref({
    colorCode: props.itemData.depositButton.colorCode,
    display: props.itemData.depositButton.display,
    path: props.itemData.depositButton.redirectUrl
})
const profileButtonData = ref({
    url: props.itemData.profileButton.url,
    display: props.itemData.profileButton.display,
    path: props.itemData.profileButton.redirectUrl
})
const openSidebar = () => {
     emits('openSidebar')
}
const openRegisterPopup = (type: number) => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') { return }
    openRegisterLoginPopup?.(type)
}
const emits = defineEmits(['goToProfile', 'intallPWA', 'isClosedPWA', 'goToGamePanel','openSidebar'])
const goToProfile = () => {
    emits('goToProfile')
}
const goToGamePannelSidePannel = (id: number) => {
    emits('goToGamePanel', id)
}
const goToDeposit = () => {
    playClickSound()
    router.push(depositButtonData.value.path)
}
const handleThemeChange = () => {
    themeChangeRef.value.open()
}
onMounted(() => {
    console.log("listGameData", props.listGameData)
    appIconData.value.url = props.itemData.appIcon.url
    appIconData.value.display = props.itemData.appIcon.display

    sideIconData.value.url = props.itemData.sideIcon.url
    sideIconData.value.display = props.itemData.sideIcon.display

    depositButtonData.value.colorCode = props.itemData.depositButton.colorCode
    depositButtonData.value.display = props.itemData.depositButton.display
    depositButtonData.value.path = props.itemData.depositButton.redirectUrl

})

const intallPWA = () => {
    emits('intallPWA');
}

const isClosedPWA = (value: any) => {
    emits('isClosedPWA', value);
}
</script>
<style scoped>
.header {
    /* top: 0; */
    z-index: 2000;
    width: 100%;
    position: fixed;
    left: 0;
    right: 0;
    display: flex;
    background-image: url('@/assets/main_bg.png');
    background-size: cover;
}

.header_item_menu {
    display: flex;
    align-items: center;
    justify-content: left;
    /* padding: 10px; */
}

.header_item_menu>>>.van-badge {
    font-size: 9px;
    margin: 5px 5px 0 0;
    line-height: 1.5;
}

.header_back_icon {
    display: flex;
    background: rgba(255, 255, 255, 0.04);
    box-shadow: inset -1px 0 0 0 rgba(255, 255, 255, 0.04);
    align-items: center;
    justify-content: center;
    padding: 0 8px;
}

.header_item_menu img {
    width: 30px;
    background: #ffffff17;
    padding: 8px 3px 8px 5px;
    opacity: 0.6;
}

.header_back_icon img {
    width: 21px;
    height: 23px;
    transform: rotate(180deg);
}

.header_item_logo {
    display: flex;
    align-items: center;
    padding: 0;
}

.header_button_item {
    /* padding: 0 18px; */
    display: flex;
    align-items: center;
    justify-content: right;
}


.header_item_logo img {
    width: 120px;
}

.footer_button_item img:first-child {
    width: 65px;
}

.footer_button_item img:nth-child(2) {
    width: 45px;
}

.login_btn {
    display: flex;
    align-items: center;
    justify-content: center;
}

.register_btn {
    display: flex;
    align-items: center;
    justify-content: center;
}

.register_btn {
    display: flex;
    align-items: center;
    justify-content: center;
}

.loginBtn {
    border-radius: 5px;
    font-size: 13px;
    color: #12151A;
    background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%);
    padding: 5px 10px;
    height: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 95%;
    margin-right: 5px;
}

.registerBtn {
    border-radius: 5px;
    font-size: 13px;
    color: #DD7A33;
    background: transparent;
    border: 1px solid #DD7A33;
    padding: 5px 10px;
    height: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 95%;
}

.van-button--small {
    height: 22px;
    width: 70px;
    border-radius: 5px;
}

.login_btn>>>.van-button--small {
    height: 1.8rem;
    border: none;
    color: #12151A;
    background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%);
}

.register_btn>>>.van-button--small {
    height: 1.8rem;
    color: #DD7A33;
    background: transparent;
    border: 1px solid #DD7A33;
    animation: icon-scale .2s ease-in-out infinite alternate;
}

.coin_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    color: #12151A;
    /* background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%); */
    font-size: 15px;
    font-weight: 700;
    border-radius: 20px;
    padding: 2px 10px;
    margin-right: 5px;
    white-space: nowrap;
    overflow: hidden;
}

.coin_btn div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
}

.coin_btn img {
    width: 10px;
    padding-left: 5px;
}

.avatar_btn img {
    width: 25px;
    border-radius: 30px;
}

.more_img img {
    width: 12px;
    position: absolute;
    margin: 15px 0px 0px -12px;
}

.top-container {
    position: fixed;
    z-index: 2000;
    width: 100%;
    left: 0;
    right: 0;
    top: 0;
}
</style>